import { FC } from 'react';
import {
  FinderResultContentStoryblok,
  GiftFinderContentStoryblok,
  GiftFinderMainContentStoryblok,
} from 'storyblok-types';
import { FinderResults } from '../Finders/Results';
import { IServerProps } from '../types';
import { GiftFinderMainContent } from './MainContent';

export const GiftFinder: FC<{
  blok: GiftFinderContentStoryblok;
  serverProps?: IServerProps;
}> = ({ blok, serverProps }) => {
  const mainContentBlok = blok?.content?.find(
    ({ component }) => component === 'giftFinderMainContent',
  );
  const finderResultBlok = blok?.content?.find(
    ({ component }) => component === 'finderResultContent',
  );

  return finderResultBlok && serverProps?.queryParams?.size ? (
    <FinderResults
      blok={finderResultBlok as FinderResultContentStoryblok}
      serverProps={serverProps}
    />
  ) : (
    <GiftFinderMainContent
      blok={mainContentBlok as GiftFinderMainContentStoryblok}
      serverProps={serverProps}
    />
  );
};
